const TRIP_TYPES = {
    MULTI_SEGMENT: 'MULTI_SEGMENT',
    ROUND_TRIP: 'ROUND_TRIP',
    ONE_WAY: 'ONE_WAY',
};

const AIRLINES = {
    KEY_PREFIX: 'itineraryStatusAirlinesGroup',
    SPLIT_BY: '#',
    GROUPS: {
        FR: 'FR',
        VY: 'VY',
        REFUND: 'REFUND',
        VOUCHER: 'VOUCHER',
        BANKRUPTCY: 'BANKRUPTCY',
        UNHANDLED: 'UNHANDLED',
    },
};
const AIRLINES_MAP_CONFIG = [
    AIRLINES.GROUPS.FR,
    AIRLINES.GROUPS.VY,
    AIRLINES.GROUPS.BANKRUPTCY,
];
const AIRLINES_MAP_CONFIG_GDS = [
    AIRLINES.GROUPS.REFUND,
    AIRLINES.GROUPS.VOUCHER,
];
const REQUEST_STATUS = {
    VOUCHER: 'VOUCHER',
    REFUND: 'REFUND',
    CHANGE: 'CHANGE',
    GENERIC: 'GENERIC',
};
const CTA_ACTION = {
    POPUP: 'POPUP',
    [REQUEST_STATUS.VOUCHER]: REQUEST_STATUS.VOUCHER,
    [REQUEST_STATUS.REFUND]: REQUEST_STATUS.REFUND,
    GO_TO_MMB: 'GO_TO_MMB',
    GO_TO_URL: 'GO_TO_URL',
};
const LINKS = {
    HELP_CENTRE: '/customer-service/#',
    CHANGE_DATES: '/customer-service/#/change/flight',
    REFUND: '/customer-service/#/cancellation/refunds',
};
const ENDPOINTS = {
    checkRefundWithMultiplePnr: '/travel/service/bookingchangerequest/checkRefundWithMultiplePnr',
    createRefundWithPnr: '/travel/service/bookingchangerequest/createRefundWithPnr',
};

const COMMENT = {
    [CTA_ACTION.VOUCHER]: 'Customer ask for Voucher via MyTrip for pnr %1$s in bookingID %2$s',
    [CTA_ACTION.REFUND]: 'Customer ask for Refund via MyTrip for pnr %1$s in bookingID %2$s',
};

const getTranslatedData = (dictionary, key, translations) => {
    const additionalData = dictionary[key] || {};
    const data = Odigeo._.merge({}, dictionary.DEFAULT, additionalData);
    return getTranslation(data, translations);
};
const getTranslation = (data, translations) => {
    const translatedData = {
        keys: {},
        data: {},
    };
    for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
            const translationAlias = data[key];

            if (typeof translationAlias === 'object') {
                const nestedTranslations = getTranslation(translationAlias, translations);
                translatedData.keys[key] = nestedTranslations.keys;
                translatedData.data[key] = nestedTranslations.data;
            } else {
                const translation = translations[translationAlias];
                if (!Odigeo._.isEmpty(translation)) {
                    translatedData.keys[key] = translation;
                } else {
                    translatedData.data[key] = translationAlias;
                }
            }
        }
    }

    return translatedData;
};

const alert = {
    DEFAULT: {
        flightReservationLabel: 'itineraryStatusAlertFlightReservationLabel',
        infoTitle: 'itineraryStatusAlertDefaultTitle',
    },
    [AIRLINES.GROUPS.FR]: {
        infoSubTitle: 'itineraryStatusAlertLOWCOSTSubtitle',
        buttonLabel: 'itineraryStatusAlertLOWCOSTButtonLabel',
        ctaAction: CTA_ACTION.POPUP,
    },
    [AIRLINES.GROUPS.VY]: {
        infoSubTitle: 'itineraryStatusAlertLOWCOSTSubtitle',
        buttonLabel: 'itineraryStatusAlertLOWCOSTButtonLabel',
        ctaAction: CTA_ACTION.POPUP,
    },
    [AIRLINES.GROUPS.VOUCHER]: {
        infoSubTitle: 'itineraryStatusAlertVOUCHERSubtitle',
        buttonLabel: 'itineraryStatusAlertVOUCHERButtonLabel',
        changesLabel: 'itineraryStatusAlertVOUCHERChangesLabel',
        ctaAction: CTA_ACTION.POPUP,
        changesDateAction: CTA_ACTION.GO_TO_URL,
        changesDateUrl: LINKS.CHANGE_DATES,
    },
    [AIRLINES.GROUPS.REFUND]: {
        infoSubTitle: 'itineraryStatusAlertREFUNDSubtitle',
        buttonLabel: 'itineraryStatusAlertREFUNDButtonLabel',
        changesLabel: 'itineraryStatusAlertREFUNDChangesLabel',
        ctaAction: CTA_ACTION.POPUP,
        changesDateAction: CTA_ACTION.GO_TO_URL,
        changesDateUrl: LINKS.CHANGE_DATES,
    },
    [AIRLINES.GROUPS.UNHANDLED]: {
        infoSubTitle: 'itineraryStatusAlertUNHANDLEDSubtitle',
        buttonLabel: 'itineraryStatusAlertUNHANDLEDMMBButtonLabel',
        ctaAction: CTA_ACTION.GO_TO_MMB,
    },
    [AIRLINES.GROUPS.BANKRUPTCY]: {
        infoTitle: 'itineraryStatusAlertBANKRUPTCYTitle',
        infoSubTitle: 'itineraryStatusAlertBANKRUPTCYSubtitle',
    },
    getData: (key, translations) => {
        return getTranslatedData(alert, key, translations);
    },
};
const popup = {
    [AIRLINES.GROUPS.FR]: {
        title: 'itineraryStatusPopupFRTitle',
        subtitle: 'itineraryStatusPopupFRSubtitle',
        point1: 'itineraryStatusPopupFRPoint1',
        airlineImageClass: 'od-itinerary-status-popup-ryanair',
        point2: 'itineraryStatusPopupFRPoint2',
        point2PNR: 'itineraryStatusPopupPoint2PNRLabel',
        point2FlightNumber: 'itineraryStatusPopupPoint2FlightNumberLabel',
        point2Email: 'itineraryStatusPopupPoint2EmailLabel',
        point3: 'itineraryStatusPopupFRPoint3',
        point4: 'itineraryStatusPopupFRPoint4',
        buttonLabel: 'itineraryStatusPopupFRButtonLabel',
        ctaAction: CTA_ACTION.GO_TO_URL,
        ctaURL: 'https://refundclaims.ryanair.com/',
    },
    [AIRLINES.GROUPS.VY]: {
        title: 'itineraryStatusPopupVYTitle',
        subtitle: 'itineraryStatusPopupVYSubtitle',
        point1: 'itineraryStatusPopupVYPoint1',
        airlineImageClass: 'od-itinerary-status-popup-vueling',
        point2: 'itineraryStatusPopupVYPoint2',
        point2PNR: 'itineraryStatusPopupPoint2PNRLabel',
        point2FlightNumber: 'itineraryStatusPopupPoint2FlightNumberLabel',
        point2Email: 'itineraryStatusPopupPoint2EmailLabel',
        point3: 'itineraryStatusPopupVYPoint3',
        point4: 'itineraryStatusPopupVYPoint4',
        buttonLabel: 'itineraryStatusPopupVYButtonLabel',
        ctaAction: CTA_ACTION.GO_TO_URL,
        ctaURL: 'https://www.vueling.com/en/we-are-vueling/contact/send-us-a-message',
    },
    [AIRLINES.GROUPS.VOUCHER]: {
        title: 'itineraryStatusPopupVOUCHERTitle',
        point1: 'itineraryStatusPopupVOUCHERPoint1',
        point2: 'itineraryStatusPopupVOUCHERPoint2',
        point3: 'itineraryStatusPopupVOUCHERPoint3',
        buttonLabel: 'itineraryStatusPopupVOUCHERButtonLabel',
        conditionsTitle: 'itineraryStatusPopupVOUCHERConditionsTitle',
        conditions: 'itineraryStatusPopupVOUCHERConditions',
        conditionsTAC: 'itineraryStatusPopupVOUCHERConditionsTAC',
        ctaAction: CTA_ACTION.VOUCHER,
        conditionsCtaAction: CTA_ACTION.GO_TO_URL,
        conditionsCtaUrl: LINKS.REFUND,
        feedback: {
            success: {
                feedbackTitle: 'itineraryStatusPopupFeedbackSuccessVOUCHERTitle',
                feedbackSubtitle: 'itineraryStatusPopupFeedbackSuccessVOUCHERSubtitle',
                messageConfirmationStyle: 'odf-message-informative-persuasive',
                messageConfirmationBoxStyle: 'odf-loading-confirm-icon',
                messageIconStyle: 'odf-icon-tick',
            },
            error: {
                feedbackTitle: 'itineraryStatusPopupFeedbackErrorVOUCHERTitle',
                feedbackSubtitle: 'itineraryStatusPopupFeedbackErrorVOUCHERSubtitle',
                messageConfirmationStyle: 'odf-message-informative-scarcity',
                messageConfirmationBoxStyle: 'odf-loading-confirm-error',
                messageIconStyle: 'odf-icon-cross-light',
            },
        },
    },
    [AIRLINES.GROUPS.REFUND]: {
        title: 'itineraryStatusPopupREFUNDTitle',
        point1: 'itineraryStatusPopupREFUNDPoint1',
        point2: 'itineraryStatusPopupREFUNDPoint2',
        point3: 'itineraryStatusPopupREFUNDPoint3',
        buttonLabel: 'itineraryStatusPopupREFUNDButtonLabel',
        conditionsTitle: 'itineraryStatusPopupREFUNDConditionsTitle',
        conditions: 'itineraryStatusPopupREFUNDConditions',
        conditionsTAC: 'itineraryStatusPopupREFUNDConditionsTAC',
        ctaAction: CTA_ACTION.REFUND,
        conditionsCtaAction: CTA_ACTION.GO_TO_URL,
        conditionsCtaUrl: LINKS.REFUND,
        feedback: {
            success: {
                feedbackTitle: 'itineraryStatusPopupFeedbackSuccessREFUNDTitle',
                feedbackSubtitle: 'itineraryStatusPopupFeedbackSuccessREFUNDSubtitle',
                messageConfirmationStyle: 'odf-message-informative-persuasive',
                messageConfirmationBoxStyle: '',
                messageIconStyle: 'odf-icon-tick',
            },
            error: {
                feedbackTitle: 'itineraryStatusPopupFeedbackErrorREFUNDTitle',
                feedbackSubtitle: 'itineraryStatusPopupFeedbackErrorREFUNDSubtitle',
                messageConfirmationStyle: 'odf-message-informative-scarcity',
                messageConfirmationBoxStyle: 'odf-loading-confirm-error',
                messageIconStyle: 'odf-icon-cross-light',
            },
        },
    },
    getData: (key, translations) => {
        return getTranslatedData(popup, key, translations);
    },
};
const layer = {
    DEFAULT: {
        infoDetails: 'infoDetails',
        flightReservationLabel: 'itineraryStatusAlertFlightReservationLabel',
        infoTitle: 'itineraryStatusAlertDefaultTitle',
    },
    [AIRLINES.GROUPS.FR]: {
        presentation: 'lowCostDetailsPresentation',
        title: 'itineraryStatusPopupFRTitle',
        subtitle: 'itineraryStatusPopupFRSubtitle',
        point1: 'itineraryStatusPopupFRPoint1',
        airlineImageClass: 'od-itinerary-status-popup-ryanair',
        point2: 'itineraryStatusPopupFRPoint2',
        point2PNR: 'itineraryStatusPopupPoint2PNRLabel',
        point2FlightNumber: 'itineraryStatusPopupPoint2FlightNumberLabel',
        point2Email: 'itineraryStatusPopupPoint2EmailLabel',
        point3: 'itineraryStatusPopupFRPoint3',
        point4: 'itineraryStatusPopupFRPoint4',
        buttonLabel: 'itineraryStatusPopupFRButtonLabel',
        ctaAction: CTA_ACTION.GO_TO_URL,
        ctaURL: 'https://refundclaims.ryanair.com/',
    },
    [AIRLINES.GROUPS.VY]: {
        presentation: 'lowCostDetailsPresentation',
        title: 'itineraryStatusPopupVYTitle',
        subtitle: 'itineraryStatusPopupVYSubtitle',
        point1: 'itineraryStatusPopupVYPoint1',
        airlineImageClass: 'od-itinerary-status-popup-vueling',
        point2: 'itineraryStatusPopupVYPoint2',
        point2PNR: 'itineraryStatusPopupPoint2PNRLabel',
        point2FlightNumber: 'itineraryStatusPopupPoint2FlightNumberLabel',
        point2Email: 'itineraryStatusPopupPoint2EmailLabel',
        point3: 'itineraryStatusPopupVYPoint3',
        point4: 'itineraryStatusPopupVYPoint4',
        buttonLabel: 'itineraryStatusPopupVYButtonLabel',
        ctaAction: CTA_ACTION.GO_TO_URL,
        ctaURL: 'https://www.vueling.com/en/we-are-vueling/contact/send-us-a-message',
    },
    [AIRLINES.GROUPS.UNHANDLED]: {
        presentation: 'gdsDetailsPresentation',
        buttonLabel: 'gdsDetailsCTA',
        ctaAction: CTA_ACTION.GO_TO_MMB,
    },
    [AIRLINES.GROUPS.BANKRUPTCY]: {
        presentation: 'bankruptcyText',
    },
    getData: (key, translations) => {
        return getTranslatedData(layer, key, translations);
    },
};
const requestStatus = {
    DEFAULT: {
        flightReservationLabel: 'itineraryStatusAlertFlightReservationLabel',
        infoTitle: 'itineraryStatusAlertDefaultTitle',
    },
    [REQUEST_STATUS.VOUCHER]: {
        messageColorClass: 'odf-text-info',
        iconClass: 'odf-icon-time',
        status: 'itineraryStatusAlertProcessingVOUCHERRequested',
    },
    [REQUEST_STATUS.REFUND]: {
        messageColorClass: 'odf-text-info',
        iconClass: 'odf-icon-time',
        status: 'itineraryStatusAlertProcessingREFUNDRequested',
    },
    [REQUEST_STATUS.CHANGE]: {
        messageColorClass: 'odf-text-info',
        iconClass: 'odf-icon-time',
        status: 'itineraryStatusAlertProcessingCHANGESDATESRequested',
    },
    [REQUEST_STATUS.GENERIC]: {
        messageColorClass: 'odf-text-info',
        iconClass: 'odf-icon-time',
        status: 'itineraryStatusAlertProcessingGENERICRequested',
    },
    getData: (key, translations) => {
        return getTranslatedData(requestStatus, key, translations);
    },
};

module.exports = {
    LINKS,
    ENDPOINTS,
    AIRLINES: {
        ...AIRLINES,
        MAP_CONFIG: [
            ...AIRLINES_MAP_CONFIG,
            ...(Odigeo.AB.isFlightStatusDesktopGds ? AIRLINES_MAP_CONFIG_GDS : []),
        ],
    },
    CTA_ACTION,
    COMMENT,
    popup,
    alert,
    layer,
    requestStatus,
    TRIP_TYPES,
};
